<template>
    <div v-loading="loading">
        <h3 style="text-align:center;">{{ $t('reports.customerClassSalesTitle') }}</h3>
        <div id="chartByCustomerClass" style="height:400px;width:400px;margin:auto;">
        </div>
        <el-table v-if="showTable"
            :data="summarizedData"
            stripe
            height="400"
            sum-text="Total"
            class="card-shadow--small"
            v-show="summarizedData &&  summarizedData.length || loading === false"
            :default-sort = "{prop: 'value', order: 'descending'}"
            show-summary
            style="width: 100%">
            <el-table-column
            prop="name"
            :label="$t('clients.class')"
            sortable
            width="180">
            </el-table-column>
            <el-table-column
                v-if="isValueBased === true"
                prop="value"
                sortable
                :label="$t('reports.values')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isAgencyFeeBased === true"
                prop="value"
                sortable
                :label="$t('products.agencyFees')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isRebateBased === true"
                prop="value"
                sortable
                :label="$t('sales_orders.rebate')">
                <template slot-scope="scope">
                    <span>{{ formatAmount(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isQuantityBased === true"
                prop="value"
                sortable
                :label="$t('common.QtyBt')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value) }}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="isQuantityBased === true"
                prop="value9L"
                sortable
                :label="$t('common.Qty9L')">
                <template slot-scope="scope">
                    <span>{{ formatNumber(scope.row.value9L) }}</span>
                </template>
            </el-table-column>
        </el-table>
</div>
</template>
<script>

import * as echarts from 'echarts';
import salesAPI from '@/services/API/sales'
import portausUtils from '@/utils/portaus-utils';

export default {
    name: 'SalesByTerritory',
    props: {
        showTable: {
        type: Boolean,
        default: false
        },
        filters: Object,
        type: {
            type: String,
            default: 'VALUE'
        },
        max: {
            type: Number,
            default: 5
        }
    },
    data() {
        return {
            loading: true,
            data: [],
        }
    },
    components: {
    },
    watch: {
        type: function (val) {
            this.initChart();
        },
        filters: function (val) {
           this.init();
        }
    },
    methods: {
        formatAmount(amount) {
            return portausUtils.formatAmount(amount, this.$i18n.locale);
        },
        formatNumber(amount) {
            return portausUtils.formatNumber(amount, this.$i18n.locale);
        },
        init() {
            this.loading = true;
            if (this.filters.inventoryId == null) return null;
            this.getSalesByCustomerClasses(this.filters)
                .then((data) => {
                    this.data = data;
                    
                    this.initChart();
                    this.loading = false;
                }).catch((err) => {
                    this.loading = false;
                })
        },
        getSalesByCustomerClasses (filters) {
            return salesAPI.getSalesByCustomerClasses(filters);
        },
        initChart () {
            this.chart = echarts.init(document.getElementById('chartByCustomerClass'));
            this.chart.setOption({
                title: {
                    show:false,
                    text: "Ventes par classe client",
                    padding:0,
                    left:'center',
                    textAlign:'center'
                },
                tooltip: {
                    show:true,
                    trigger: 'item',
                    appendToBody: true,
                },
                legend: {
                    show:false,
                    orient: 'vertical',
                    left: 'left',
                    selectedMode: false,
                },
                series: [
                    {
                        // name: 'Ventes / Type.',
                        type: 'pie',
                        radius: ['40%', '60%'],
                        avoidLabelOverlap: false,
                        itemStyle: {
                        borderRadius: 10,
                        borderColor: '#fff',
                        borderWidth: 2
                        },
                        label: {
                            show: true,
                            overflow: 'break',
                            width: 75,
                        },
                        labelLine: {
                            show: true
                        },
                        data: this.chartData,
                    }
                ]
            });
            this.chart.on('click', (params) => this.$emit('change', params.data));
        }
    },
    computed : {
        isQuantityBased () { 
            return _.upperCase(this.type) === 'QUANTITY';
        },
        isValueBased () { 
            return _.upperCase(this.type) === 'VALUE';
        },
        isAgencyFeeBased () { 
            return _.upperCase(this.type) === 'AGENCYFEES';
        },
        isRebateBased () { 
            return _.upperCase(this.type) === 'REBATE';
        },
        chartData () {
            return _.map(this.dataByType, data => ({ id: data.id, value: data.value, name: `${data.name}`, tooltip: { valueFormatter: (value) => !this.isQuantityBased ?  '$' + value : value }}))
        },
        dataByType() {
            if (this.isQuantityBased === true) {
                return this.dataByQty;
            } else if (this.isAgencyFeeBased === true) {
                return this.dataByAgencyFees;
            } else if (this.isRebateBased === true) {
                return this.dataByRebate;
            }           
            return this.dataByValue;

        },
        summarizedData () {
            if (this.max >= 0) {
                return _.slice(this.dataByType, 0, this.max);
            } else {
                return this.dataByType;
            }
           
        },
        dataByValue () {
            return _.orderBy(_.map(this.data, d => ({id: d.customerClassId, name: d.code, value: Number(d.value), valueOrder: Number(d.value)})), ['valueOrder'], ['desc']);
        },
        dataByQty () {
            return _.orderBy(_.map(this.data, d => ({id: d.customerClassId, name: d.code, value: Number(d.qty), value9L: Number(d.qty9l) })), ['qty'], ['desc']);
        },
        dataByAgencyFees () {
            return _.orderBy(_.map(this.data, d => ({id: d.customerClassId, name: d.code, value: Number(d.agencyfees), valueOrder: Number(d.agencyfees)})), ['valueOrder'], ['desc']);
        },
        dataByRebate () {
            return _.orderBy(_.map(this.data, d => ({id: d.customerClassId, name: d.code, value: Number(d.discount), valueOrder: Number(d.discount)})), ['valueOrder'], ['desc']);
        }
    },
    mounted() {
        this.init();
        
    }
   
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>


</style>
  